<template>
<div>
    <div class="rolemanage w-label">
      <div class="card card-border" >
        <el-form ref="forms">
          <div class="card-con">
            <el-form-item label="用户名：" prop="yhm">
              <span>{{baseInfoData.id}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="mx">
              <!--<span>姓名</span>-->
              <el-input  type="text" placeholder="姓名" v-model="nickName"></el-input>
            </el-form-item>
            <el-form-item label="出生年月：" prop="ml">
              <el-date-picker
                v-model="birthday"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="分销渠道：" prop="qd">
              <span>{{baseInfoData.channelName}}</span>
            </el-form-item> -->
            <el-form-item label="身份：" prop="sf">
              <span>会员</span>
            </el-form-item>
          </div>
          <div class="wx-con">
            <el-form-item label="微信昵称：" prop="wx">
              <span>{{baseInfoData.wechatName}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="tel">
              <!--<span>手机号</span>-->
              <el-input  type="text" placeholder="请输入手机号" v-model="customerMobile"></el-input>
            </el-form-item>
            <el-form-item label="性别：" prop="xb">
              <el-select v-model="sex" placeholder="请选择性别">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册时间：" prop="zsy">
                <span>{{baseInfoData.created}}</span>
            </el-form-item>
            
          </div>
          <span class="user_pic">
            <img :src="baseInfoData.headImg" >
          </span>
        </el-form>
      </div>
    </div>
    <div class="rolemanage w-label">
      <div class="card">
        <el-form ref="forms" >
          <div class="card-con">
            <el-form-item label="总收入：" prop="zsy">
            <span>{{baseInfoData.totalIncome ? baseInfoData.totalIncome : "--"}}</span>
            </el-form-item>
            <el-form-item label="可提现余额：" prop="ye">
              <span>{{baseInfoData.balance ? baseInfoData.balance : "--"}}</span>
            </el-form-item>
            <el-form-item label="积分：" prop="jf">
              <span>{{baseInfoData.integral ? baseInfoData.integral : "--"}}</span>
            </el-form-item>
          </div>
          <div class="wx-con">
            <el-form-item label="累计提现收入：" prop="ljysr">
              <span>{{baseInfoData.cumulatedBalance ? baseInfoData.cumulatedBalance : "--"}}</span>
            </el-form-item>
            <el-form-item label="待转正收入：" prop="dshy">
              <span>{{baseInfoData.positiveBalance ? baseInfoData.positiveBalance : "--"}}</span>
            </el-form-item>
            <el-form-item label="他的订单：" prop="dd">
              <span>{{baseInfoData.order ? baseInfoData.order : "--"}}</span>
            </el-form-item>
            </div>
        </el-form>
      </div>
    </div>
    <div class="common_nav_header">
        <span></span>
        <span>利益关系</span>
    </div>
    <div class="tab-con">
      <com-table :baseInfoData="baseInfoData" :getLevel="getLevel"></com-table>
    </div>
    <div class="h-button-warpper save-btn">
      <span class="orgBtn" @click='save()'>保存</span>
      <span class="orgBtn" @click='back()'>返回</span>
    </div>
</div>
</template>
<script>
import comTable from '../comTable/index.vue'
import commonMixin from '@/mixins/common.js'
import { saveDistributerDeatil } from '../../../api/request'
export default {
  components: {
    comTable
  },
  props: ['baseInfoData', 'getDistributer'],
  data() {
    return {
      infoText: [],
      path: '',
      user: '',
      region: '',
      activeName: 'first',
      nickName: '',
      customerMobile: '',
      birthday: '',
      sex: ''
    }
  },
  mixins: [commonMixin],
  created() {},
  methods: {
    getLevel(val) {
      let level = ''
      switch (val) {
        case 1:
          level = '一级分销商'
          break
        case 2:
          level = '二级分销商'
          break
        case 0:
          level = '会员'
          break
      }
      return level
    },
    back() {
      const path = '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fmember_list.json'
      this.goBack(path)
    },
    save() {
      const _this = this
      // 效验手机号
      if (!/^1[34578]\d{9}$/.test(_this.customerMobile)) {
        this.$message.warning('请填写正确的手机号~')
        return false
      }
      const params = {
        'customerId': _this.baseInfoData.id,
        'nickName': _this.nickName,
        'sex': _this.sex,
        'customerMobile': _this.customerMobile,
        'birthday': _this.birthday
      }
      saveDistributerDeatil('/customer/user/modifyDistributor', 'post', params).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          const path = '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fmember_list.json'
          this.goBack(path)
          this.delMyself({ path: this.$route.path })
          this.$nextTick(() => {
            this.$bus.$emit('refresh-grid')
          })
          // this.$emit('getDistributer')
        } else if (res.code === 1001) {
          this.$message('服务器内部异常')
        } else if (res.code === 1002) {
          this.$message('登录凭证无效')
        } else {
          this.$message('没有权限')
        }
      }).catch(errData => {
        this.$message.error('error 出错了')
        console.log(errData)
      })
    }
  },
  watch: {
    'baseInfoData'(val) {
      console.log(val)
      this.nickName = val.nickName
      this.customerMobile = val.customerMobile
      this.sex = val.sex
      this.birthday = val.birthday
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.white-bg-radius{
  padding:20px 30px;
  position: relative;
}
.rolemanage {
  display:flex;
  padding-left:80px;
  .card{
    margin-bottom:10px;
    .el-form {
      position:relative;
      box-sizing: border-box;
      display: flex;
      .card-con{
        min-width:420px;
        flex:1
      }
      .wx-con{
        flex:1
      }
      .el-form-item {
        display: flex;
        text-align: left;
        margin:10px 20px;
        .el-form-item__label{
          width:180px;
          text-align: left;
          padding-right:5px;
        }
        .el-input, .el-textarea {
          display: inline-block;
          width:177px;
        }
      }
    }
    .upload-pr{
      position:relative;
    }
    .upload-tip{
      position:absolute;
      bottom:10px;
      right:10px;
      font-size:12px;
      color:#999
    }
    .user_pic{
      position:absolute;
      top:0px;
      left:-80px;
      width:80px;
      height:80px;
      overflow:hidden;
      background:url('../../../assets/image/wo.jpg');
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .card-border{
    border-bottom:1px solid #f3f5f7;padding-bottom:10px
  }
  .tab-con{
    width:70%;
  }
}
.orgBtn {
  display: inline-block;
  vertical-align: top;
  width: 62px;
  margin-top: 10px;
  text-align: center;
}
.save-btn{
  position: absolute;
  top: 90px;
  right: 25px;
}
</style>
<style >
.w-label .el-form-item__label{
    width:100px;
    margin-right:10px;
    color:#111;
}
</style>


// WEBPACK FOOTER //
// src/_app/outlet/src/views/memberBaseInfo/common/baseInfo.vue